import { type ScenarioGraph } from 'types/api/scenarios/scenario'

export enum ScenarioPreviewSentinels {
  Dependency = 'DEPENDENCY_ID_SENTINEL',
  RandomDNS = 'RANDOM_DNS_SERVER_SENTINEL',
  RandomZone = 'RANDOM_ZONE_SENTINEL',
  ServiceId = 'SERVICE_ID_SENTINEL',
  StatusCheck = 'STATUS_CHECK_ID_SENTINEL'
}

// This enum is intended to exclusively serve the External Action sections of the scenario graph
export enum ExternalActionPreviewSentinels {
  AutoscalingGroup = 'AUTOSCALING_GROUP_SENTINEL'
}

export enum ScenarioPreviewMetadataKey {
  Dependency = 'Dependency',
  Service = 'Service'
}

export interface ScenarioPreview {
  graph: ScenarioGraph
  metadata: ScenarioPreviewMetadataKey[]
}
